import { createApi } from '@reduxjs/toolkit/query/react'
import { axiosBaseQuery } from '../axiosBaseQuery'
import { AccountStructure, AccountStructureForm } from '../../models/accounts-structure'
import { TicketHebType } from '../../models/types'


export const accountsStructureApi = createApi({
  reducerPath: 'accountsStructureApi',
  baseQuery: axiosBaseQuery({ baseUrl: '/api/' }),
  tagTypes: [
    'accountsStructure',
  ],
  endpoints: (b) => ({
    

    // ---------- GET ----------

    getAccountStructure: b.query<AccountStructure[], TicketHebType>({
      query: (accountType) => ({ 
        url: 'accounts-structure/search',
        method: 'POST',
        data: {"account_type": accountType}
      }),
      providesTags: (_res, _err, accountType) => [
        { type: 'accountsStructure', id: accountType },
      ],
      keepUnusedDataFor: Infinity,
    }),

    
    // ---------- PATCH ----------

    editAccountStructure: b.mutation<AccountStructure, AccountStructure>({
      query: (accountStructureToUpdate) => ({
        url: `accounts-structure/${accountStructureToUpdate.id}`,
        method: 'PATCH',
        data: accountStructureToUpdate,
      }),
      async onQueryStarted(accountStructureToUpdate, { dispatch, queryFulfilled }) {
        const patch = dispatch(
          accountsStructureApi.util.updateQueryData('getAccountStructure', accountStructureToUpdate.account_type, draft => {
            const row = draft.find(t => t.id === accountStructureToUpdate.id)
            if (row) Object.assign(row, accountStructureToUpdate)
          })
        )
        try { await queryFulfilled } catch { patch.undo() }
      },
      invalidatesTags: (_res, _err, accountType) => [
        { type: 'accountsStructure', id: accountType.id },
      ],
    }),


    // ---------- POST ----------
    
    addCustomAccountStructure: b.mutation<AccountStructure, AccountStructureForm>({
      query: (customAccountStructure) => ({
        url: `accounts-structure`,
        method: 'POST',
        data: customAccountStructure,
      }),
      async onQueryStarted(customAccountStructure, { dispatch, queryFulfilled }) {
        const temp: AccountStructure = {
          ...customAccountStructure, 
          id: 99999, 
          business_id: 99999, 
          created_at: "", 
          updated_at: "", 
          field_table: customAccountStructure.field_table ?? null,
          custom_field: customAccountStructure.custom_field ?? null,
          location: customAccountStructure.location ?? null,
        }
        const patch = dispatch(
          accountsStructureApi.util.updateQueryData('getAccountStructure', customAccountStructure.account_type, draft => {
            draft.push(temp)
          })
        )
        try {
          const { data: created } = await queryFulfilled
          dispatch(
            accountsStructureApi.util.updateQueryData('getAccountStructure', customAccountStructure.account_type, draft => {
              const i = draft.findIndex(x => x.id === temp.id)
              if (i >= 0) draft[i] = created
            })
          )
        } catch {
          patch.undo()
        }
      },
      invalidatesTags: (_res, _err, { account_type }) => [
        { type: 'accountsStructure', id: account_type},
      ],
    }),

  }),
})

export const {
  useGetAccountStructureQuery,
  useEditAccountStructureMutation,
  useAddCustomAccountStructureMutation,
} = accountsStructureApi
